export const gitCommit = '7429078f'
